import { useFetch } from "../useFetch";
import type { DiscountResponse, CreateDiscountPayload } from "../../core/types/control/";

// ============================================
// GET ALL DISCOUNTS
// ============================================
export function useAllDiscounts() {
	return useFetch<DiscountResponse[]>({
		endpoint: `/discounts/`,
		method: "GET",
	});
}

// ============================================
// GET DISCOUNTS BY USER
// ============================================
export function useDiscountsByUser(userId: number) {
	return useFetch<DiscountResponse[]>({
		endpoint: `/discounts/user/${userId}`,
		method: "GET",
		auto: userId > 0,
		initialData: [],
	});
}

// ============================================
// GET DISCOUNT BY ID
// ============================================
export function useDiscount(id: number) {
	return useFetch<DiscountResponse>({
		endpoint: `/discounts/${id}`,
		method: "GET",
	});
}

// ============================================
// CREATE DISCOUNT
// ============================================
export function useCreateDiscount() {
	const fetch = useFetch<DiscountResponse, CreateDiscountPayload>({
		endpoint: "/discounts",
		method: "POST",
		auto: false,
	});

	const create = (data: CreateDiscountPayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, create };
}

// ============================================
// SPEND DISCOUNT
// ============================================
export function useSpendDiscount() {
	// Al no enviar un body, volvemos a dejar un solo tipo genérico (la respuesta)
	const fetch = useFetch<DiscountResponse>({
		endpoint: "/discounts", // Endpoint base temporal
		method: "PATCH",
		auto: false,
	});

	// 👈 MODIFICADO: Recibimos ambos IDs y los pasamos en la URL
	const spend = (discountId: number, userId: number) => {
		return fetch.execute({
			endpoint: `/discounts/${discountId}/spend/${userId}`,
		});
	};

	return { ...fetch, spend };
}

// ============================================
// UPDATE DISCOUNT STATUS (ACTIVATE / DEACTIVATE)
// ============================================
export function useUpdateDiscountStatus() {
	const fetch = useFetch<DiscountResponse, { is_active: boolean }>({
		endpoint: "/discounts",
		method: "PATCH",
		auto: false,
	});

	const updateStatus = (id: number, isActive: boolean) => {
		return fetch.execute({
			endpoint: `/discounts/${id}/status`,
			body: { is_active: isActive },
		});
	};

	return { ...fetch, updateStatus };
}
